import { Link, useParams } from "react-router-dom";
import { POLICIES, POLICY_VERSION, POLICY_EFFECTIVE_DATE, BUSINESS } from "@/lib/policies";

function renderBody(text) {
  return text.split(/\n\n+/).map((block, i) => {
    if (block.startsWith("## ")) {
      return <h2 key={i} className="text-lg font-bold text-slate-900 mt-6 mb-2">{block.slice(3)}</h2>;
    }
    return <p key={i} className="text-sm text-slate-700 leading-relaxed mb-3 whitespace-pre-wrap">{block}</p>;
  });
}

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];
  if (!policy) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24" data-testid="policy-not-found">
        <h1 className="text-2xl font-bold text-slate-900">Policy not found</h1>
        <Link to="/" className="mt-4 inline-block text-sm text-slate-500 hover:text-slate-900">← Back to home</Link>
      </div>
    );
  }
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid={`policy-page-${slug}`}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-1">The Repair Nook · Policy</div>
      <h1 className="text-3xl font-bold text-slate-900" data-testid="policy-title">{policy.title}</h1>
      <div className="mt-3 text-xs text-slate-500 space-x-3">
        <span>Effective {POLICY_EFFECTIVE_DATE}</span>
        <span>·</span>
        <span>Last updated {POLICY_EFFECTIVE_DATE}</span>
        <span>·</span>
        <span data-testid="policy-version">Version {POLICY_VERSION}</span>
      </div>

      <article className="mt-8">{renderBody(policy.body)}</article>

      <div className="mt-10 pt-6 border-t border-slate-200 text-xs text-slate-600">
        <div className="font-semibold text-slate-800 mb-1">Contact</div>
        <div>{BUSINESS.name}</div>
        <div>{BUSINESS.address_line1}</div>
        <div>{BUSINESS.city_state_zip}</div>
        <div>{BUSINESS.phone} · {BUSINESS.email}</div>
        <div className="mt-2 italic">{BUSINESS.service_area}</div>
      </div>

      <div className="mt-8">
        <Link to="/" className="text-sm text-slate-500 hover:text-slate-900">← Back to home</Link>
      </div>
    </div>
  );
}
